import styled from 'styled-components'
import { BREAKPOINTS, COLOURS } from 'resources'

import RoundedButton from 'components/RoundedButton'

export const SpinnerContainer = styled.div`
  min-height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`

export const NetworkFeeModalDescription = styled.div`
  font-size: 18px;
  padding: 20px 0;
`
export const NetworkFeeModalButton = styled(RoundedButton)`
  width: 100%;
`
export const ScreenTitle = styled.div`
  font-family: 'Druk', sans-serif;
  line-height: 1;
  font-size: 46px;
  padding: 40px 20px;
  text-align: left;
  color: ${COLOURS.neutralWhite};
  background-color: ${COLOURS.neutralBlack};

  @media (min-width: ${BREAKPOINTS.md}) {
    font-size: 70px;
    text-align: center;
  }
`
export const ContentContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: stretch;
  flex-direction: column;
  max-width: 450px;
  width: 100%;
  margin: auto;
`
